module.exports = __webpack_public_path__ + "static/horus_03-089431897bd7b2e0205f2f452b6e8ec5.jpg";